import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";

const KEY = "lf_cookie_consent";

export const getCookieConsent = () => {
  try { return localStorage.getItem(KEY); } catch (err) { console.warn("Cookie consent unavailable", err); return null; }
};

const enableAnalytics = () => {
  if (typeof window.__lfEnableAnalytics === "function") window.__lfEnableAnalytics();
};

export function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const stored = getCookieConsent();
    if (stored === "accepted") enableAnalytics();
    else if (!stored) setVisible(true);
  }, []);

  const decide = (value) => {
    try { localStorage.setItem(KEY, value); } catch (err) { console.warn("Cookie consent not persisted (private mode?)", err); }
    if (value === "accepted") enableAnalytics();
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      role="dialog"
      aria-live="polite"
      aria-label="Cookie consent"
      data-testid="cookie-banner"
      className="fixed inset-x-4 bottom-4 z-[90] mx-auto max-w-3xl rounded-2xl border border-white/10 bg-[#0A1628]/95 p-5 shadow-2xl backdrop-blur-xl sm:inset-x-6 sm:p-6"
    >
      <div className="flex flex-col gap-4 sm:flex-row sm:items-center">
        <span className="hidden h-10 w-10 shrink-0 items-center justify-center rounded-xl border border-[#00D4AA]/30 bg-[#00D4AA]/10 sm:inline-flex">
          <Cookie className="h-5 w-5" style={{ color: "#00D4AA" }} strokeWidth={1.8} />
        </span>
        <div className="flex-1 text-sm leading-relaxed text-slate-300">
          <p className="font-medium text-white">We use cookies to understand how firms use LeaseFlow.</p>
          <p className="mt-1 text-slate-400">
            Essential cookies keep you signed in. Optional analytics cookies (PostHog) only run if you accept — you can change your mind any time in our{" "}
            <Link to="/privacy" className="underline decoration-[#00D4AA]/50 underline-offset-2 hover:text-white" data-testid="cookie-privacy-link">
              privacy policy
            </Link>
            .
          </p>
        </div>
        <div className="flex shrink-0 gap-2">
          <button type="button" onClick={() => decide("rejected")} className="btn-ghost !px-4 !py-2 text-sm" data-testid="cookie-reject-btn">
            Essential only
          </button>
          <button type="button" onClick={() => decide("accepted")} className="btn-accent !px-4 !py-2 text-sm" data-testid="cookie-accept-btn">
            Accept all
          </button>
        </div>
      </div>
    </div>
  );
}
